import React from "react";
import ReactDOM from "react-dom";
import {
  HashRouter as Router
} from "react-router-dom";

// import 'antd/dist/antd.css';
import "./index.css";
import App from "./App";

console.log('ok');
ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);